import React, {useMemo} from 'react';
import {Platform, Text, View} from 'react-native';
import {Container} from '../../../../shared/components/container';
import {AcceptorCardProps} from './model';
import {Image} from '../../../../shared/components/image';
import {images} from '../../../../assets/icons';
import {useTheme} from '../../../../shared/theme';
import {formatPhone, openExternalLink, openExternalPhone} from '../../../../shared/pipes';
import {Button} from '../../../../shared/components/button';
import getStyles from './styles';
import {LK_PROD_ESKMO, LK_TEST_ESKMO} from '../../../volunteersService/components/dobroWebView';

export default ({acceptor: {name, logo, phone, webSiteURL}}: AcceptorCardProps) => {
  const theme = useTheme();
  const styles = getStyles();

  const PhoneIcon = images.Phone;

  const absoluteImgLink = useMemo(
    () =>
      Platform.OS === 'web'
        ? logo
        : logo?.startsWith('http')
        ? logo
        : `${__DEV__ ? LK_TEST_ESKMO : LK_PROD_ESKMO}${logo}`,
    [logo],
  );

  return (
    <Container style={styles.container}>
      <View>
        <Image style={styles.logo} source={{uri: absoluteImgLink}} resizeMode='contain' />
      </View>
      <View>
        <Text style={styles.text}>{name}</Text>
      </View>
      <View style={styles.phone}>
        <PhoneIcon width={18} height={18} color={theme.color.primaryColor} />
        <Text style={styles.phoneText} onPress={() => openExternalPhone(formatPhone(phone))}>
          {formatPhone(phone)}
        </Text>
      </View>
      <Button
        style={styles.button}
        id='acceptor-link'
        type='transparent'
        text='Веб-сайт'
        onPress={() => openExternalLink(webSiteURL)}
        disabled={!webSiteURL}
      />
    </Container>
  );
};
